export const createUsersSearchPayload = (data = { terms: {} }) => {
  const parameters = {
    pageSize: data.pageSize || 25,
    pageNumber: data.pageNumber || 0,
    name: data.name || '',
    type: data.type || '',
    terms: {
      search: data.terms.search || '',
      clientId: data.terms.clientId || [],
      casId: data.terms.casId || [],
      institutionId: data.terms.institutionId || [],
      userRoleId: data.terms.userRoleId || [],
      status: data.terms.status || [],
      internalUser: data.terms.internalUser || [],
    }
  }
  return parameters;
}